import { Action } from '../../shared/models/action.model';
import { updateAction } from '../../utils/utility';
import { AdmissionForm, CardCollapse } from '../models/newAdmissionModel';
import actionTypes from '../types/newAdmissionTypes';

interface BenefSearchRequiredDetail {
  benefDetail: any;
}

export const benefSearch = (
  benefDetail: any,
  updateBeneficiaryList: (benefList: any[]) => void,
  failedBeneficiarySearch: (errorMessage: any, AllowNextStage: boolean, showRetryMessage: any) => void,
): Action<BenefSearchRequiredDetail> => updateAction(
  actionTypes.BENEF_SEARCH,
  { benefDetail, updateBeneficiaryList, failedBeneficiarySearch },
);

export const beneficiarySearchForHISAction = (
  HISBenefSearchPayload: Record<string, any>,
  HISBenefSuccess: (benefList: any[], memberSearchRequest: Record<string, any>) => void,
  failedHISBenefSearch: (errorMessage: any, AllowNextStage: boolean, showRetryMessage: any) => void,
): Action<Record<string, any>> => (
  { type: actionTypes.HIS_BENEF_SEARCH, ...{ HISBenefSearchPayload, HISBenefSuccess, failedHISBenefSearch } }
);

export const setSelectedTab = (selectedTab: number): Action<{ selectedTab: number }> =>
  ({ type: actionTypes.SET_SELECTED_TAB, ...{ selectedTab } });

export const setProcedureID = (automatedProcedureId: number): Action<{ automatedProcedureId: number }> =>
  ({ type: actionTypes.SET_AUTOMATED_PROCEDURE_ID, ...{ automatedProcedureId } });

export const setSelectedAilmentValues = (selectedAilmentValues: any): Action<{ selectedAilmentValues: number }> =>
  ({ type: actionTypes.SET_SELECTED_AILMENT_VALUES, ...{ selectedAilmentValues } });

export const setMappedAilmentValues = (mappedAilmentValues: any): Action<{ selectedAilmentValues: number }> =>
  ({ type: actionTypes.SET_MAPPED_AILMENT_VALUES, ...{ mappedAilmentValues } });

export const setPltID = (proposedLineTreatmentId: number): Action<{ proposedLineTreatmentId: number }> =>
  ({ type: actionTypes.SET_PLT_ID, ...{ proposedLineTreatmentId } });

export const setAdmissionForm = (admissionFormVal: { [x: string]: any }): Action<AdmissionForm> => ({
  type: actionTypes.SET_ADMISSION_FORM_VAL, ...{ admissionFormVal } }
);

export const setIsShowAdmissionForm = (isShowAdmissionForm: boolean): Action<boolean> => ({
  type: actionTypes.SET_IS_SHOW_ADMISSION_FORM, ...{ isShowAdmissionForm },
});

export const setInsurerID = (selectedInsurerId: any): Action<any> => ({
  type: actionTypes.SET_SELECTED_INSURER_ID, ...{ selectedInsurerId },
});
export const setCorporateName = (selectedCorporateName: any): Action<any> => ({
  type: actionTypes.SET_CORPORATE_NAME, ...{ selectedCorporateName },
});

export const setAdditionalAdmissionInfo = (additionalAdmissionInfo: any): Action<any> => ({
  type: actionTypes.SET_ADDITIONAL_ADMISSION_INFO, ...{ additionalAdmissionInfo } }
);

export const setBeneficiaryList = (beneficiaryList: any[]): Action<any[]> => ({
  type: actionTypes.SET_BENEFICIARY_LIST, ...{ beneficiaryList },
});

export const setBenefSearchReqObject = (memberSearchRequest: Record<string, any>): Action<any[]> => ({
  type: actionTypes.SET_BENEFICIARY_REQUEST_OBJECT, ...{ memberSearchRequest },
});

export const setSelectedBeneficiary = (beneficiary: any): Action<any[]> => ({
  type: actionTypes.SELECT_BENEFICIARY, ...{ beneficiary },
});

export const setClaimDetailBackupBeneficiary = (payload: any): Action<any[]> => ({
  type: actionTypes.SELECT_CLAIMDETAIL_BACKUP, ...{ payload },
});

export const setSelectedBenfStatus = (beneficiaryStatus: any): Action<any[]> => ({
  type: actionTypes.SELECTED_BENEFICIARY_STATUS, ...{ beneficiaryStatus },
});

export const setUploadedFiles = (uploadedFiles: any[]): Action<any[]> => ({
  type: actionTypes.UPLOAD_FILES, ...{ uploadedFiles },
});

export const setToggleClick = (toggleClick: boolean): Action<boolean> => ({
  type: actionTypes.TOGGLE_CLICK, ...{ toggleClick },
});
export const setFileDialogOpen = (openFileDialogOnClick: boolean): Action<boolean> => ({
  type: actionTypes.SET_FILE_DIALOG_OPEN, ...{ openFileDialogOnClick },
});
export const setLinkAbhaClick = (linkAbhaClick: boolean): Action<boolean> => ({
  type: actionTypes.LINK_ABHA_CLICK, ...{ linkAbhaClick },
});
export const setShowShareDocumentOptionsModal = (showShareDocumentOptionsModal: boolean): Action<boolean> => ({
  type: actionTypes.SHOW_SHARE_DOCUMENT_OPTIONS_MODAL, ...{ showShareDocumentOptionsModal },
});
export const createHealthBankUser = (payload: any, onSuccess: any, onError: any): Action<any> => ({
  type: actionTypes.CREATE_HEALTHBANK_USER, ...{payload, onSuccess, onError},
});
export const setHealthBankUser = (newHealthBankUserId: string | undefined): Action<any> => ({
  type: actionTypes.SET_NEW_HEALTHBANK_USER, ...{newHealthBankUserId},
});
export const fetchHealthBankUserProfile = (newHealthBankUserId: any, onSuccess: any, onError: any): Action<any> => ({
  type: actionTypes.FETCH_HEALTHBANK_USER_PROFILE_DETAILS, ...{newHealthBankUserId, onSuccess, onError},
});
export const setShowAbhaLinkModal = (showAbhaLinkModal: boolean): Action<any> => ({
  type: actionTypes.SET_SHOW_ABHA_LINK_MODAL, ...{showAbhaLinkModal},
});
export const setHealthbankUserSignupOption = (healthbankUserSignupOption: string): Action<any> => ({
  type: actionTypes.SET_HEALTHBANK_USER_SIGNUP_OPTION, ...{healthbankUserSignupOption},
});
export const setDocumentUploadSuccess = (documentUploadSuccess: boolean): Action<any> => ({
  type: actionTypes.SET_DOCUMENT_UPLOAD_SUCCESS, ...{documentUploadSuccess},
});
export const setMaxSizeForFile = (maximumFileSizeAllowed: number): Action<any> => ({
  type: actionTypes.MAX_FILE_SIZE_ALLOWED, ...{ maximumFileSizeAllowed },
});
export const setMobileOnScreen = (mobileOnScreen: boolean): Action<boolean> => ({
  type: actionTypes.MOBILE_ON_SCREEN, ...{ mobileOnScreen },
});
export const setMobileVerification = (mobileVerification: boolean): Action<boolean> => ({
  type: actionTypes.MOBILE_VERIFICATION, ...{ mobileVerification },
});
export const setHealthVaultEnable = (healthVaultEnable: boolean): Action<boolean> => ({
  type: actionTypes.HEALTH_VAULT_ENABLE, ...{ healthVaultEnable },
});
export const setHealthVaultDocumentUpload = (healthVaultDocumentUpload: boolean): Action<boolean> => ({
  type: actionTypes.HEALTH_VAULT_DOCUMENT_UPLOAD, ...{ healthVaultDocumentUpload },
});
export const setEnableMobileOTP = (enableMobileOtp: boolean): Action<boolean> => ({
  type: actionTypes.ENABLE_MOBILE_OTP, ...{ enableMobileOtp },
});
export const setEnableAadhaarOTP = (enableAadhaarOtp: boolean): Action<boolean> => ({
  type: actionTypes.ENABLE_AADHAAR_OTP, ...{ enableAadhaarOtp },
});
export const setAadharVerficationSuccess = (aadharVerificationSuccess: boolean): Action<boolean> => ({
  type: actionTypes.SET_AADHAR_VERIFICATION_SUCCESS, ...{ aadharVerificationSuccess },
});
export const setEnableAadhar = (enableAadhar: boolean): Action<boolean> => ({
  type: actionTypes.ENABLE_AADHAR, ...{ enableAadhar },
});
export const setUserPresent = (userPresent: boolean): Action<boolean> => ({
  type: actionTypes.SET_USER_PRESENT, ...{ userPresent },
});
export const setUsersNotFound = (usersNotFound: boolean): Action<boolean> => ({
  type: actionTypes.SET_USERS_NOT_FOUND, ...{ usersNotFound },
});
export const setCheckAllDocs = (checkAll: boolean): Action<boolean> => ({
  type: actionTypes.SET_CHECK_ALL, ...{ checkAll },
});
export const setMobileNo = (mobileNumberValue: string): Action<any> => ({
  type: actionTypes.MOBILE_NO_VALUE, ...{ mobileNumberValue },
});
export const setTempProfile = (tempProfile: any): Action<any> => ({
  type: actionTypes.TEMP_PROFILE, ...{ tempProfile },
});
export const setEncryptedTxn = (encryptedTxn: string): Action<any> => ({
  type: actionTypes.ENCRYPTED_NO_VALUE, ...{ encryptedTxn },
});
export const setTxnId = (txnID: string): Action<any> => ({
  type: actionTypes.TXN_ID, ...{ txnID },
});
export const setHospActionId = (hospActionID: string): Action<any> => ({
  type: actionTypes.HOSP_ACTION_ID, ...{ hospActionID },
});
export const setDOA = (doaValue: string): Action<any> => ({
  type: actionTypes.DOA_VALUE, ...{ doaValue },
});
export const setMobileOTP = (mobileOtp: string): Action<any> => ({
  type: actionTypes.MOBILE_OTP, ...{ mobileOtp },
});
export const setAadhaarOTP = (aadhaarOtp: string): Action<any> => ({
  type: actionTypes.AADHAAR_OTP, ...{ aadhaarOtp },
});
export const setAadharNo = (aadharNumberValue: string): Action<any> => ({
  type: actionTypes.AADHAR_NO_VALUE, ...{ aadharNumberValue },
});

export const setbillAmountArray = (billAmountArray: any[]): Action<any[]> => ({
  type: actionTypes.SET_BILLAMOUNT_ARRAY, ...{ billAmountArray },
});

export const setClassificationArray = (classificationArray: any[]): Action<any[]> => ({
  type: actionTypes.SET_CLASSIFICATION_ARRAY, ...{ classificationArray },
});
// Note : userProfilesArray is not an array , it is an object with 'userProfiles' as a list of users
export const setUserProfiles = (userProfilesArray: any): Action<any[]> => ({
  type: actionTypes.SET_USER_PROFILES, ...{ userProfilesArray },
});
export const setFileNames = (uploadedFilesName: any[]): Action<any[]> => ({
  type: actionTypes.SET_UPLOADED_FILE_NAMES, ...{ uploadedFilesName },
});
export const setFileGUID = (uploadedFilesGUID: any[]): Action<any[]> => ({
  type: actionTypes.SET_UPLOADED_FILE_GUID, ...{ uploadedFilesGUID },
});
export const setFileTypes = (uploadedFileTypes: any[]): Action<any[]> => ({
  type: actionTypes.SET_UPLOADED_FILE_TYPES, ...{ uploadedFileTypes },
});
export const setDocumentList = (uploadedFileList: any[]): Action<any[]> => ({
  type: actionTypes.SET_UPLOADED_FILE_LIST, ...{ uploadedFileList },
});
export const setCheckedList = (checkedFileList: any[]): Action<any[]> => ({
  type: actionTypes.SET_CHECKED_FILE_LIST, ...{ checkedFileList },
});
export const setNonAvailableClassification = (nonAvailableClassification: any[]): Action<any[]> => ({
  type: actionTypes.NON_AVAILABLE_CLASSIFICATION, ...{ nonAvailableClassification },
});

export const setFinalMandatoryClassifications = (finalMandatoryClassifications: any[]): Action<any[]> => ({
  type: actionTypes.FINALDOCS, ...{ finalMandatoryClassifications },
});

export const setIsFileProcessInProgress = (isFileProcessInProgress: boolean): Action<any[]> => ({
  type: actionTypes.IS_FILE_PROCESS_IN_PROGRESS, ...{ isFileProcessInProgress },
});

export const setPercent = (percent: number): Action<any[]> => ({
  type: actionTypes.SET_PERCENT, ...{ percent },
});

export const submitAdmission =
  (form: any, isEdit: boolean, onSuccess: any, onError: any)
  : Action<any[]> => {
    return {
      type: actionTypes.SUBMIT_ADMISSION, ...{ form, isEdit, onSuccess, onError },
    };
  };

export const downloadClaimPDF = (payload: any, onCallback?: any): Action<any[]> => {
  return {
    type: actionTypes.DOWNLOAD_CLAIM_PDF, ...{ payload, onCallback },
  };
};
export const printClaimPDF = (payload: any, onCallback?: any): Action<any[]> => {
  return {
    type: actionTypes.PRINT_CLAIM_PDF, ...{ payload, onCallback },
  };
};
export const hisPrintClaimPDF = (payload: any, onCallback?: any): Action<any[]> => {
  return {
    type: actionTypes.HIS_PRINT_CLAIM_PDF, ...{ payload, onCallback },
  };
};
export const setIsMinimize = (isMinimize: boolean): Action<any[]> => ({
  type: actionTypes.IS_MINIMIZE, ...{ isMinimize },
});

export const setIsShowOtherMinimize = (showOtherMinimize: boolean): Action<any[]> => ({
  type: actionTypes.IS_SHOW_OTHER_MINIMIZE, ...{ showOtherMinimize },
});

export const setIsModal = (settlementModal: boolean): Action<any[]> => ({
  type: actionTypes.IS_MODAL, ...{ settlementModal },
});

export const updateDraftValue = (draftValue: string): Action<any[]> => ({
  type: actionTypes.UPDATE_DRAFT_VALUE, ...{ draftValue },
});

export const setGoToNext = (goToNext: boolean): Action<any[]> => ({
  type: actionTypes.GO_TO_NEXT, ...{ goToNext },
});

export const setClickedOnSkip = (clickedOnSkip: boolean): Action<any[]> => ({
  type: actionTypes.CLICKED_ON_SKIP, ...{ clickedOnSkip },
});

export const setPatientConsentProceedClicked = (patientConsentProceedClicked: boolean): Action<any[]> => ({
  type: actionTypes.PATIENT_CONSENT_PROCEED_CLICKED, ...{ patientConsentProceedClicked },
});

export const setSelectedConsentOptions = (consentOption: string): Action<any[]> => ({
  type: actionTypes.SET_SELECTED_CONSENT_OPTION, ...{ consentOption },
});

export const setSelectedConsentOptionStyle = (consentOptionStyle: any): Action<any[]> => ({
  type: actionTypes.SET_SELECTED_CONSENT_OPTION_STYLE, ...{ consentOptionStyle },
});

export const setConsentDateTime = (consentDateTime: any): Action<any[]> => ({
  type: actionTypes.SET_CONSENT_DATE_TIME, ...{ consentDateTime },
});

export const setIsComeFromSubmit = (isComeFromSubmit: boolean): Action<any[]> => ({
  type: actionTypes.IS_COME_FROM_SUBMIT, ...{ isComeFromSubmit },
});

export const setCardCollapse = (cardCollapse: CardCollapse): Action<any[]> => ({
  type: actionTypes.SET_CARD_COLLAPSE, ...{ cardCollapse },
});

export const clearNewAdmissionState = (): Action<void> => ({ type: actionTypes.CLEAR_STATE });

export const updateSelectedCenter = (selectedCenter: any): Action<void> => ({
  type: actionTypes.UPDATE_SELECTED_CENTER, ...{selectedCenter},
});

export const setIsSubmitClicked = (isSubmitClicked: boolean): Action<void> => ({
  type: actionTypes.SET_IS_SUBMIT_CLICKED,
  ...{ isSubmitClicked },
});

export const setIsSuccessModalNewAdmission = (isSuccessModalNewAdmission: boolean): Action<void> => ({
  type: actionTypes.SET_IS_SUCCESS_MODAL_NEW_ADMISSION,
  ...{ isSuccessModalNewAdmission },
});

export const setSubmitWithoutDocsClicked = (submitWithoutDocsClicked: boolean): Action<any> =>
  updateAction(actionTypes.SET_SUBMIT_WITHOUT_DOCS_CLICKED, submitWithoutDocsClicked);

export const updatePackageSelection = (selectedPackage: any[]): Action<void> => ({
  type: actionTypes.UPDATE_PACKAGE_SELECTION, ...{selectedPackage},
});

export const clearSelectedPackage = (): Action<void> => ({
  type: actionTypes.CLEAR_SELECTED_PACKAGE,
});

export const setExtraFormValues = (extraFormValues: any = {}): Action<void> => ({
  type: actionTypes.SET_EXTRA_FORM_VALUES, ...{ extraFormValues },
});

export const setIsLoadingPreData = (isLoadingPreData: boolean): Action<void> => ({
  type: actionTypes.IS_LOADING_PRE_DATA, ...{ isLoadingPreData },
});

export const submitIr = (form: any, onSuccess: any, onError: any): Action<void> => ({
  type: actionTypes.SUBMIT_IR, ...{ form, onSuccess, onError },
});

export const submitSettlement = (form: any, onSuccess: any, onError: any): Action<void> => ({
  type: actionTypes.SUBMIT_SETTLEMENT, ...{ form, onSuccess, onError },
});

export const submitSettlementCourierTrack = (form: any, onSuccess: any, onError: any): Action<void> => ({
  type: actionTypes.SUBMIT_SETTLEMENT_COURIER, ...{ form, onSuccess, onError },
});

export const setConditionOnDischarge = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_CONDITION_ON_DISCHARGE, payload);

export const updateModalFormValue = (modalFormValue: any): Action<void> => ({
  type: actionTypes.MODAl_FORM_VALUES, ...{ modalFormValue },
});

export const submitCancelClaim = (IsUserAccepted: boolean, onSuccess: any, onError: any): Action<void> => ({
  type: actionTypes.CANCEL_CLAIM, ...{ IsUserAccepted, onSuccess, onError },
});

export const paymentAcknowledge = (payload: any, onSuccess: any, onError: any): Action<any[]> => ({
  type: actionTypes.PAYMENT_ACKNOWLEDGE, ...{payload, onSuccess, onError},
});

export const setMemberName = (memberName: string): Action<void> => ({
  type: actionTypes.UPDATE_MEMBER_NAME, ...{ memberName },
});

export const setIsAbhaVerified = (isAbhaVerified: any, abhaIdVerifiedData: any): Action<void> => ({
    type: actionTypes.SET_IS_ABHA_ID_VERIFIED, ...{ isAbhaVerified, abhaIdVerifiedData },
});

export const setIsComponentRendered = (isComponentRendered: boolean): Action<void> => ({
  type: actionTypes.SET_IS_COMPONENT_RENDERED, ...{ isComponentRendered },
});

export const setIsDraftSelected = (isDraftSelected: boolean): Action<void> => ({
  type: actionTypes.SET_IS_DRAFT_SELECTED, ...{ isDraftSelected },
});

export const setSelectedDraft = (selectedDraft: boolean): Action<void> => ({
  type: actionTypes.SET_SELECTED_DRAFT, ...{ selectedDraft },
});

export const setHospitalWisePayerList = (hospitalWisePayerList: string): Action<void> => ({
  type: actionTypes.SET_HOSPITAL_WISE_PAYER_LIST, ...{ hospitalWisePayerList },
});

export const enableManualSubmission = (): Action<void> => ({ type: actionTypes.MANUAL_SUBMISSION });

export const setExistingClaimError = (payload: any): Action<void> => updateAction(actionTypes.SET_EXISTING_CLAIM_ERROR, payload);
export const setNewAdminssionSearchVal = (newAdmissionSearchValues: any = {}): Action<void> => ({
  type: actionTypes.SET_NEW_ADMISSION_SEARCH_VAL, ...{ newAdmissionSearchValues },
});

export const checkDuplicateClaim = (payload: any): Action<void> => ({type: actionTypes.CHECK_DUPLICATE_CLAIM, payload});

export const setGetHealthIdCard = (payload: any): Action<void> => updateAction(actionTypes.GET_HEALTH_ID_CARD, payload);

export const setHealthCardType = (payload: any): Action<void> => updateAction(actionTypes.SET_HEALTH_CARD_TYPE, payload);

export const setIsDischargeCase = (payload: boolean): Action<any> =>
  updateAction(actionTypes.SET_IS_DISCHARGE_CASE, payload);

export const setIsCovidCase = (payload: boolean): Action<any> =>
  updateAction(actionTypes.SET_IS_COVID_CASE, payload);

export const setDelayedAdmission = (payload: boolean): Action<any> =>
  updateAction(actionTypes.DELAYED_ADMISSION, payload);

export const setLOSgt90 = (payload: boolean): Action<any> =>
  updateAction(actionTypes.LOSgt90, payload);

export const updateDefaultTimeline = (payload: any): Action<any> =>
  updateAction(actionTypes.UPDATE_DEFAULT_TIMELINE, payload);

export const downloadDocumentGuids = (payload: any): Action<any> =>
  updateAction(actionTypes.DOWNLOAD_DOCUMENTS_GUIDS, payload);

export const setProbability = (payload: any): Action<any[]> =>
  updateAction(actionTypes.SET_PROBABILITY, payload);

export const setSelectedDiscrepency = (payload: any): Action<any[]> =>
  updateAction(actionTypes.SET_SELECTED_DISCREPENCY, payload);

export const setNonSelectedDiscrepency = (payload: any): Action<any[]> =>
  updateAction(actionTypes.SET_NON_SELECTED_DISCREPENCY, payload);

export const updateAdditionalMandatoryDocuments = (payload: any): Action<any> =>
  updateAction(actionTypes.UPDATE_ADDITIONAL_MANDATORY_DOCS, payload);

export const updateAutomatedProceduresOptions = (payload: any): Action<any> =>
  updateAction(actionTypes.UPDATE_AUTOMATED_PROCEDURE_OPTIONS, payload);

export const setFormAction = (payload: string): Action<any> =>
  updateAction(actionTypes.SET_FORM_ACTION, payload);

export const toggleOtherProcedure = (payload: boolean): Action<any> =>
  updateAction(actionTypes.TOGGLE_OTHER_PROCEDURE, payload);

export const toggleOtherRoomType = (payload: boolean): Action<any> =>
  updateAction(actionTypes.TOGGLE_OTHER_ROOM_TYPE, payload);

export const sethospDetailsForRoomType = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_HOSP_DETAILS_FOR_ROOM_TYPE, payload);

export const setHospitalOtherRoomType = (payload: string): Action<any> =>
  updateAction(actionTypes.HOSPITAL_OTHER_ROOM_TYPE, payload);

export const setStatusName = (payload: string): Action<any> => {
  return updateAction(actionTypes.SET_STATUS_NAME, payload);
};

export const disableRoomType = (flag: any): Action<any> =>
  updateAction(actionTypes.DISABLE_ROOM_TYPE, flag);

export const setHidConfirmationMessage = (payload: any): Action<any> =>
  updateAction(actionTypes.HID_CONFIRMATION, payload);

export const fetchAbhVerificationMethods = (payload: string): Action<any> =>
  updateAction(actionTypes.FETCH_ABHA_VERIFICATION_METHODS, payload);

export const fetchAbhVerificationMethodsSuccess = (payload: any): Action<any> =>
  updateAction(actionTypes.FETCH_ABHA_VERIFICATION_METHODS_SUCCESS, payload);

export const fetchAbhVerificationMethodsFailure = (payload: any): Action<any> =>
  updateAction(actionTypes.FETCH_ABHA_VERIFICATION_METHODS_FAILURE, payload);

export const abhaVerificationSentOtp = (payload: any): Action<any> =>
  updateAction(actionTypes.ABHA_VERIFICATION_SENT_OTP, payload);

export const abhaVerificationSentOtpSuccess = (payload: any): Action<any> =>
  updateAction(actionTypes.ABHA_VERIFICATION_SENT_OTP_SUCCESS, payload);

export const abhaVerificationSentOtpFaulire = (): Action<any> =>
    updateAction(actionTypes.ABHA_VERIFICATION_SENT_OTP_FAILURE, {});

export const conformOtpForAbhaId = (payload: any): Action<any> =>
  updateAction(actionTypes.ABHA_CONFIRM_OTP, payload);

export const abhaConfirmOtpSuccess = (payload: any): Action<any> =>
  updateAction(actionTypes.ABHA_CONFIRM_OTP_SUCCESS, payload);

export const abhaConfirmOtpError = (): Action<any> =>
  updateAction(actionTypes.ABHA_CONFIRM_OTP_ERROR, {});

export const createAbhaAlreadyExist = (payload: any): Action<any> =>
  updateAction(actionTypes.CREATE_ABHA_ALREADY_EXIST, payload);

export const updateBillDetails = (updatedBillDetail: any): Action<any> =>
  updateAction(actionTypes.UPDATE_BILL_DETAILS, updatedBillDetail);

export const updateAdmissionStartTime = (time: string): Action<any> =>
  updateAction(actionTypes.UPDATE_ADMISSION_START_TIME, time);

export const setAdmissionFormType = (type: string): Action<any> =>
  updateAction(actionTypes.CHANGE_FORM_TYPE, type);

export const toggleFileUploadByForce = (isEnabled: boolean): Action<any> =>
  updateAction(actionTypes.TOGGLE_ENABLE_FILE_UPLOAD_FORCE, isEnabled);

export const resetDetailNav = (): Action<void> =>
  updateAction(actionTypes.RESET_DETAIL_NAV);

export const getSelectedSearchType = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_SELECTED_SEARCH_TYPE, payload);

export const toggleCSVMismatchModal = (flag: boolean): Action<any> =>
  updateAction(actionTypes.TOGGLE_CSV_MISMATCH, flag);

export const csvRetry = (flag: boolean): Action<any> =>
  updateAction(actionTypes.CSV_RETRY, flag);

export const getOldClaimDetails = (selectedBenef: any, onSuccess: any): Action<any> =>
  updateAction(actionTypes.GET_OLD_CLAIM_DETAIL, { selectedBenef, onSuccess });

export const getDrivingLicenseVerification = (payload: any, onSuccess: any, onError: any): Action<any[]> => {
  return{
    type: actionTypes.DRIVING_LICENSE_VERIFICATION, ...{payload, onSuccess, onError},
  };
};

export const getVoterIdVerification = (payload: any, onSuccess: any, onError: any): Action<any[]> => {
  return{
    type: actionTypes.VOTER_ID_VERIFICATION, ...{payload, onSuccess, onError},
  };
};

export const setDlVerified = (payload: boolean): Action<any> =>
  updateAction(actionTypes.SET_DL_VERIFIED, payload);

export const setVoterIdVerified = (payload: boolean): Action<any> =>
  updateAction(actionTypes.SET_VOTERID_VERIFIED, payload);

export const setDobLoading = (payload: boolean): Action<any> =>
  updateAction(actionTypes.SET_DOB_LOADING, payload);

export const setDobModal = (payload: boolean): Action<any> =>
  updateAction(actionTypes.DOB_MODAL_VISIBLE, payload);

export const setAutoPopulateDayCareProcedure = (flag: boolean): Action<any> =>
  updateAction(actionTypes.SET_AUTO_POPULATE_DAY_CARE_TOGGLE, flag);

export const setDynamicQuestionFields = (fields: any): Action<any> =>
  updateAction(actionTypes.SET_DYNAMIC_QUESTION_FIELDS, fields);

export const updateSettlementType = (type: string): Action<any> =>
    updateAction(actionTypes.SET_SETTLEMENT_TYPE, type);

export const generateVerificationOTP = (payload: any, onSuccess: any, onError: any): Action<any[]> => {
    return{
      type: actionTypes.GET_AADHAR_OTP, ...{payload, onSuccess, onError},
    };
  };

 export const verificationAadharOtp = (payload: any, onSuccess: any, onError: any): Action<any[]> => {
    return{
      type: actionTypes.VERIFY_AADHAR_OTP, ...{payload, onSuccess, onError},
    };
  };

export const getpanVerification = (payload: any, onSuccess: any, onError: any): Action<any[]> => {
  return{
    type: actionTypes.PAN_VERIFICATION, ...{payload, onSuccess, onError},
  };
};

export const setAdhaarLoading = (payload: boolean): Action<any> =>
  updateAction(actionTypes.SET_ADHAAR_LOADING, payload);

export const setVerificationModal = (payload: boolean): Action<any> =>
  updateAction(actionTypes.OTP_MODAL_VISIBLE, payload);

export const setSelectedOption = (payload: string): Action<any> =>
  updateAction(actionTypes.SET_SELECTED_OPTION, payload);

export const setAadhaarResponse = (payload: string): Action<any> =>
  updateAction(actionTypes.SET_AADHAAR_RESPONSE, payload);

export const setSuccessModal = (payload: boolean): Action<any> =>
   updateAction(actionTypes.SET_SUCCESS_MODAL, payload);

export const setAdharVerified = (payload: boolean): Action<any> =>
   updateAction(actionTypes.SET_ADHAAR_VERIFIED, payload);

export const setNameAdharVerified = (payload: boolean): Action<any> =>
  updateAction(actionTypes.SET_NAME_ADHAAR_VERIFIED, payload);

export const setPanVerified = (payload: boolean): Action<any> =>
   updateAction(actionTypes.SET_PAN_VERIFIED, payload);

export const setPanNoVerified = (payload: boolean): Action<any> =>
  updateAction(actionTypes.SET_PAN_NO_VERIFIED, payload);

export const setPageChangeAllowed = (payload: boolean): Action<any> =>
   updateAction(actionTypes.SET_PAGE_CHANGE_ALLOWED, payload);

export const setSpecialityOptions = (payload: any): Action<any> =>
   updateAction(actionTypes.SET_SPECIALITY_OPTIONS, payload);

export const setPanField = (payload: any): Action<any> =>
   updateAction(actionTypes.SET_PAN_NUMBER, payload);

export const setBuddhimedSelectedFiles = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_BUDDHIMED_SELECTED_FILES, payload);

export const setPreviouslyUploadedFiles = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_PREVIOUSLY_UPLOADED_FILES, payload);

export const setPanRequired = (payload: any): Action<any> =>
   updateAction(actionTypes.SET_PAN_REQUIRED, payload);

export const setBeneficiaryPopUpRequired = (payload: boolean): Action<any> =>
  updateAction(actionTypes.SET_BENEFICIARY_POPUP_FLAG, payload);

export const setBeneficiarySearchResponsePayerId = (payload: number): Action<any> =>
  updateAction(actionTypes.SET_BENEFICIARY_SEARCH_RESPONSE_PAYER_ID, payload);

export const setBeneficiarySearchResponsePayerName = (payload: string): Action<any> =>
  updateAction(actionTypes.SET_BENEFICIARY_SEARCH_RESPONSE_PAYER_NAME, payload);

export const setShowPayerNotConfiguredMessage = (payload: boolean): Action<any> =>
  updateAction(actionTypes.SET_SHOW_PAYER_NOT_CONFIGURED_MSG, payload);

export const setShowPayerUpdatedMessage = (payload: boolean): Action<any> =>
  updateAction(actionTypes.SET_SHOW_PAYER_UPDATED_MSG, payload);

export const setShowBeneficiaryCard = (payload: boolean): Action<any> =>
  updateAction(actionTypes.SET_SHOW_BENEFICIARY_CARD, payload);

export const setPLTChanged = (payload: any): Action<any> =>
   updateAction(actionTypes.IS_PLT_CHANGED, payload);

export const setPLTMappedValue = (payload: any): Action<any> =>
  updateAction(actionTypes.PLT_MAPPED_VALUE, payload);

export const setAilmentValue = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_AILMENT_VALUE, payload);

export const setPayerRoomType = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_PAYER_ROOM_TYPE, payload);

export const setBillDetailVal = (billdetailValues: any = {}): Action<void> => ({
  type: actionTypes.SET_NEW_BILL_DETAIL_VAL, ...{ billdetailValues },
});

export const setIPNumberPopup = (payload: any): Action<void> =>
  updateAction(actionTypes.ENABLE_IPNUMBER_POPUP, payload);

export const setsubmitDisabled = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_SUBMIT_DISABLED, payload);

export const setModalSwitch = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_MODAL_SWITCH, payload);

export const setPanVerificationRequired = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_PAN_VERIFICATION_REQUIRED, payload);

export const setDraftFormValidated = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_DRAFT_FORM_VALIDATED, payload);

export const setShowAccidentCard = (payload: any): Action <any> =>
  updateAction(actionTypes.SET_SHOW_ACCIDENT_CARD, payload);

export const setHoursDifference = (payload: any): Action <any> =>
  updateAction(actionTypes.SET_HOURS_DIFFERENCE, payload);

export const setDateApplied = (payload: any): Action <any> =>
  updateAction(actionTypes.SET_DATE_APPLIED, payload);

export const setIsShowingDoADoDEnhancementModal = (payload: boolean): Action <any> =>
  updateAction(actionTypes.SET_IS_DOA_DOD_ENHANCEMENT_MODAL_OPEN, payload);

export const setIsNewBornCase = (payload: boolean): Action <any> =>
  updateAction(actionTypes.SET_NEW_BORN_CASE, payload);

export const setMemberSearchId = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_MEMBER_SEARCH_ID, payload);

export const setSelectedCardIndex = (payload: any): Action<any> =>
 updateAction(actionTypes.SET_SELECTED_MEMBER_CARD, payload);

 export const setSelectedMemberId = (payload: any): Action<any> =>
 updateAction(actionTypes.SET_MEMBER_ID, payload);

export const setPercentageNameMatch = (payload: any): Action<any> =>
 updateAction(actionTypes.SET_PERCENTAGE_NAME_MATCH, payload);

export const setIsDeathCase = (payload: boolean): Action <any> =>
  updateAction(actionTypes.SET_IS_DEATH_CASE, payload);

export const setDiagnosisFromPayerLookUp = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_DIAGNOSIS_FROM_PAYER_LOOKUP, payload);

export const setProcedureFromPayerLookUp = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_PROCEDURE_FROM_PAYER_LOOKUP, payload);

export const setGovtSchemeUrn = (payload: any): Action<any> =>
 updateAction(actionTypes.SET_GOVT_SCHEME_URN, payload);

export const setDefaultClaim = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_DEFAULT_CLAIM, payload);

export const setDaycareCase = (payload: boolean): Action<any> =>
  updateAction(actionTypes.SET_DAYCARE_CASE, payload);

export const uploadTickerFile = (onSuccess: any, onError: any): Action<any[]> => {
  return{
    type: actionTypes.UPLOAD_TICKER_CONFIGURATOR, ...{onSuccess, onError},
  };
};
  export const saveTickerData = (payload: any, onSuccess: any, onError: any): Action<any[]> => {
    return{
      type: actionTypes.SAVE_TICKER_DATA, ...{payload, onSuccess, onError},
    };
};

export const fetchApplicationConfiguration = (payload: any, onSuccess: any, onError: any): Action<any[]> => {
  return {
    type: actionTypes.GET_APPLICATION_CONFIGURATION, ...{ payload, onSuccess, onError },
  };
};

export const updateApplicationConfiguration = (payload: any, onSuccess: any, onError: any): Action<any[]> => {
  return {
    type: actionTypes.UPDATE_APPLICATION_CONFIGURATION, ...{ payload, onSuccess, onError },
  };
};

export const setHisSelectedFiles = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_HIS_SELECTED_FILES, payload);

 export const setHisCheckedFiles = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_HIS_CHECKED_FILES, payload);

 export const setUpdatedLetters = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_UPDATED_LETTERS, payload);

 export const submitFile = (payload: any, onSuccess?: any, onError?: any): Action<any> => {
  return{
    type: actionTypes.SUBMIT_HIS_FILE, ...{payload, onSuccess, onError},
  };
 };

 export const setFiles = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_FILES, payload);

 export const setHisFileSize = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_HIS_FILE_SIZE, payload);

export const mergeDemergeClaims = (payload: any, onSuccess: any, onError: any): Action<any[]> => {
  return {
    type: actionTypes.MERGE_DEMERGE_CLAIMS, ...{ payload, onSuccess, onError },
  };
};

export const setPayerDocs = (payerDocs: any[]): Action<any[]> => ({
  type: actionTypes.PAYER_DOCUMENTS, ...{ payerDocs },
});

export const setSelectedDoctorList = (selectedDoctorList: any = {}): Action<void> => ({
  type: actionTypes.SET_SELECTED_DOCTOR_LIST, ...{ selectedDoctorList },
});

export const setPatientSignature = (patientSignature: any = {}): Action<void> => ({
  type: actionTypes.SET_PATIENT_SIGNATURE, ...{ patientSignature },
});

export const setAllowNextStage = (payload: boolean): Action<any> => {
  return {
    type: actionTypes.SET_ALLOW_NEXT_STAGE, ...{ payload },
  };
};

export const setStarDisabledBenefMessage = (payload: string): Action<any> => {
  return {
    type: actionTypes.SET_STAR_DISABLED_BENEF_MESSAGE, ...{ payload },
  };
};

export const setIsSubmitClickedFromModal = (payload: boolean): Action<any> => {
  return {
    type: actionTypes.SET_SUBMIT_BTN_FROM_MODAL, ...{payload},
  };
};
export const setHyphenGroup = (payload: boolean): Action<any> => {
  return {
    type: actionTypes.SET_HYPHENATED_GROUP, ...{ payload },
  };
};

export const setIsArtemis = (payload: boolean): Action<any> => {
  return {
    type: actionTypes.SET_IS_ARTEMIS, ...{ payload },
  };
};
